export default __webpack_public_path__ + "img/Poppins-ExtraBold_24a3185.woff";